import React, { useState } from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';



const styles = theme => ({
	input: {
		display: 'flex',
		padding: 0,
	},
	valueContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		flex: 1,
		alignItems: 'center',
		overflow: 'hidden',
	},
	chip: {
		margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
	},
	chipFocused: {
		backgroundColor: emphasize(
			theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
			0.08,
		),
	},
	noOptionsMessage: {
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
	},
	singleValue: {
		fontSize: 16,
	},
	placeholder: {
		position: 'absolute',
		left: 2,
		fontSize: 16,
	},
	paper: {
		position: 'absolute',
		zIndex: 1,
		marginTop: theme.spacing.unit,
		left: 0,
		right: 0,
	},
	divider: {
		height: theme.spacing.unit * 2,
	},
});

function NoOptionsMessage(props) {
	return (
		<Typography
			color="textSecondary"
			className={props.selectProps.classes.noOptionsMessage}
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
}

function inputComponent({ inputRef, ...props }) {
	return <div ref={inputRef} {...props} />;
}

function Control(props) {
	return (
		<TextField
			fullWidth
			InputProps={{
				inputComponent,
				inputProps: {
					className: props.selectProps.classes.input,
					inputRef: props.innerRef,
					children: props.children,
					...props.innerProps,
				},
			}}
			{...props.selectProps.textFieldProps}
		/>
	);
}

function Option(props) {
	return (
		<MenuItem
			buttonRef={props.innerRef}
			selected={props.isFocused}
			component="div"
			style={{
				fontWeight: props.isSelected ? 500 : 400,
			}}
			{...props.innerProps}
		>
			{props.children}
		</MenuItem>
	);
}

function Placeholder(props) {
	return (
		<Typography
			color="textSecondary"
			className={props.selectProps.classes.placeholder}
			{...props.innerProps}
		>
			{props.children}
		</Typography>
	);
}

function SingleValue(props) {
	return (
		<Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
			{props.children}
		</Typography>
	);
}

function ValueContainer(props) {
	return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
	return (
		<Chip
			tabIndex={-1}
			label={props.children}
			className={classNames(props.selectProps.classes.chip, {
				[props.selectProps.classes.chipFocused]: props.isFocused,
			})}
			onDelete={props.removeProps.onClick}
			deleteIcon={<CancelIcon {...props.removeProps} />}
		/>
	);
}

function Menu(props) {
	return (
		<Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
			{props.children}
		</Paper>
	);
}

const components = {
	Control,
	Menu,
	MultiValue,
	NoOptionsMessage,
	Option,
	Placeholder,
	SingleValue,
	ValueContainer,
};

const RegionsSelect = ({ regionsOptions, setRegions, language, classes, theme }) => {
	const [positionSearchItem, setPositionSearchItem] = useState(0);
	const [inputValue, setInputValue] = useState('');

	const selectStyles = {
		input: base => ({
			...base,
			color: theme.palette.text.primary,
			'& input': {
				font: 'inherit',
				fontSize: "16px!important",
			},
		}),
		indicatorsContainer: (provided) => ({
			...provided,
			cursor: 'pointer' // Set cursor to pointer for indicators
		})
	};

	return (
		<Select
			classes={classes}
			styles={selectStyles}
			options={regionsOptions}
			components={components}
			onKeyDown={(e) => {
				if (e.keyCode === 13) {
					// console.log("Enter pressed");
					e.preventDefault();
				}
			}}
			value={positionSearchItem}
			onInputChange={(inputText) => {
				setInputValue(inputText);
			}}
			onChange={value => {
				setRegionSearchItem(value);
				setRegions(regions => {
					var newRegions = { ...regions };
					Object.keys(newRegions).forEach(key => {
						if (value && parseInt(newRegions[key]['ID']) === parseInt(value['id'])) {
							newRegions[key]['selected'] = true;
						} else {
							newRegions[key]['selected'] = false;
						}
					});
					return newRegions;
				});
			}}
			getOptionLabel={(option) => {
				let label = option['label'];
				if (inputValue.length > 0) {
					const indexInlabel = option['label'].toLowerCase().indexOf(inputValue.toLowerCase());

					if (indexInlabel >= 0) {
						label = (<>{label.substring(0, indexInlabel)}<mark style={{ backgroundColor: "#58cee8" }}>{label.substring(indexInlabel, indexInlabel + inputValue.length)}</mark>{label.substring(indexInlabel + inputValue.length)}</>);
					}
				}
				return label;
			}}
			noOptionsMessage={() => language === "en" ? "No options found" : "Keine Optionen gefunden"}
			//getOptionValue={(option) => `${option['id']}`}
			//getOptionLabel={(option) => <><strong>{option['parentName']}</strong>&nbsp;→&nbsp;<small>{option['name']}</small></>}
			placeholder="Region"
			isMulti
		/>
	);

}

RegionsSelect.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(RegionsSelect);
